class RpcError extends Error {
    constructor(message, name='UnkownError',  expose=false, status=500, remoteStack='') {
        super(message);
        this.name = name;
        this.expose = expose;
        this.status = status
        this.remoteStack = remoteStack
    }
}

module.exports = RpcError;